import YurtSVG from "../../../../YurtSVG";
import Moment from "react-moment";
import styled from "styled-components";
import { useRef } from "react";
import { findTax, findTotalTax, findFundsReceived } from "../functions";
import { formatter } from "../../constants";
import { motion } from "framer-motion";
import { useReactToPrint } from "react-to-print";

import PreviewKit from "./Kit";
import Printable from "./printable/Printable";

let today = Date.now();

const niceGrey = "rgb(120, 120, 120)";

const Container = styled.div`
  background: white;
  padding: 12px;
  display: flex;
  flex-direction: column;
  position: relative;
  box-shadow: 7px 7px 10px rgb(0 0 0 / 7%);
  margin-bottom: 40px;

  position: relative;
  p {
    margin: 0;
  }
`;

const Print = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  margin: 10px;
  padding: 5px;
  font-size: 10px;
`;

const Header = styled.div`
  display: flex;
  svg {
    fill: ${({ color }) => color};
  }
`;

const Tag = styled.div`
  font-size: 8px;
  padding: 0px 5px;
  color: ${niceGrey};
`;

const Title = styled.div`
  color: black;
  font-weight: 700;
  font-size: 18px;
  display: flex;
  align-items: baseline;
  justify-content: flex-end;
  margin-bottom: 5px;
  text-transform: capitalize;
`;

const DateTitle = styled.small`
  margin-left: 40px;
  font-size: 10px;
`;

const Details = styled.div`
  width: 100%;
  background: ${({ color }) => color};
  border-radius: 5px;
  padding: 10px;
  display: flex;
  *,
  p {
    color: white;
  }
`;

const Personal = styled.div`
  width: 50%;
  p {
    font-size: 8px;
  }
`;

const Name = styled.div`
  font-size: 19px;
  font-weight: 700;
`;

const Address = styled.div`
  p {
    font-size: 8px;
  }
  width: 25%;
`;

const DatesContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 5px;
`;

const MoneyDates = styled.div`
  border: 1px solid #798b7922;
  display: flex;
  justify-content: space-between;
  margin: 10px 0px;
  border-radius: 5px;
  * {
    font-size: 9px;
  }
`;
const DateItem = styled.div`
  min-width: 20%;
  padding: 10px;
`;

const DateValue = styled.div`
  color: ${niceGrey};
`;

const DateAmount = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  color: ${niceGrey};
  span {
    color: ${({ color }) => color};
    font-weight: 700;
    padding-left: 5px;
  }
`;

const ProductionDates = styled.div`
  border: 1px solid #798b7922;
  display: flex;
  justify-content: space-evenly;
  margin: 10px 0px;
  border-radius: 5px;
  width: max-content;
  * {
    font-size: 9px;
  }
  /* flex: 2; */
`;

const TableTop = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  padding: 5px;
  border-radius: 3px;
  justify-content: space-between;
  div {
    background: ${({ color }) => color};
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 3px;
    opacity: 0.2;
  }
  p {
    margin: 0px;
    font-weight: 900;
    font-size: 10px;
  }
`;

const Tax = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 5px 5px;
  font-size: 10px;
  font-weight: 700;
  color: #a0a0a0;

  span {
    padding: 0 10px;
    color: grey;
  }
`;

const Total = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 7px;
  border-radius: 3px;
  font-size: 12px;
  color: ${({ color }) => color};
  font-weight: 900;
  background: rgb(240, 240, 240);
`;
const SubTotal = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 7px;
  border-radius: 3px;
  font-size: 12px;
  color: grey;
  font-weight: 900;
  border: 1px solid grey;
  margin-top: 10px;
`;

const BalanceDue = styled.div`
  border: 2px solid black;
  display: flex;
  justify-content: space-between;
  padding: 7px;
  border-radius: 3px;
  font-size: 12px;
  color: ${({ color }) => color};
  font-weight: 900;
`;

const Important = styled.div`
  font-size: 8px;
  padding: 5px 0;
  text-align: right;
`;

const Notes = styled.div`
  position: relative;
  display: flex;
  padding: 10px;
  border: 1px solid grey;
  color: grey;
  font-size: 10px;
`;

const NoteHeader = styled.div`
  position: absolute;
  background: white;
  padding: 0 2px;
  top: -8px;
  left: 10px;
  color: grey;
  font-size: 8px;
`;

const Terms = styled.div`
  display: flex;
  padding: 10px 0;
  justify-content: space-between;
  margin-bottom: 30px;
`;

const PSA = styled.div`
  font-size: 10px;
  color: grey;
  width: 48%;
`;

const Signature = styled.div`
  width: 48%;
  font-size: 12px;
`;

const Sign = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 5px;
  font-weight: 700;
  span {
    width: 60%;
    border-bottom: 1px solid black;
  }
`;

const Footer = styled.div`
  font-size: 8px;
`;

const PrintContainer = styled.div`
  position: absolute;
  background: white;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  display: none;
  @media print {
    display: block;
  }
`;

const Item = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  padding-left: 5px;
  font-size: 10px;
  font-weight: 700;
  color: grey;
  border-top: 1px solid #ededed;
`;

const ItemTitle = styled.div`
  text-transform: capitalize;
`;
const ItemAmount = styled.div``;

const PreviewForm = ({ value, document, colors }) => {
  const printRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  const color = colors[document.type];

  const {
    firstName,
    lastName,
    phoneNumber,
    email,
    mailingStreetAddress,
    mailingCity,
    mailingRegion,
    mailingZipCode,
    mailingCountry,
    deliveryStreetAddress,
    deliveryCity,
    deliveryCountry,
    deliveryRegion,
    deliveryZipCode,
  } = value;

  const {
    depositDue,
    fiftyDue,
    fullDue,
    productionDate,
    shipDate,
    title,
    tax,
    notes,
    psa,
    psaDefault,
    kits,
    type,
    showDates,
  } = document;

  return (
    <div>
      <PrintContainer ref={printRef}>
        <Printable value={value} document={document} colors={colors} showDates={showDates}/>
      </PrintContainer>

      <Container
        as={motion.div}
        initial={{ x: 25, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.5 }}
        exit={{ x: 25, opacity: 0 }}
        layout
      >
        <Print onClick={() => handlePrint()}>SAVE</Print>

        <Header color={color}>
          <YurtSVG width="2.5rem" />

          <Tag>
            <b>Smiling Woods Yurts</b>
            <br />
            28 Horizon Flat Rd
            <br />
            Winthrop, WA 98862
            <br />
            (509) 996-9878
            <br />
            accounting@smilingwoodsyurts.com
            <br />
            smilingwoods.com
          </Tag>
        </Header>

        <Title>
          {title}
          <DateTitle>
            <Moment date={today} format="MM/DD/YY" />
          </DateTitle>
        </Title>

        <Details color={color}>
          <Personal>
            <Name>
              {firstName} {lastName}
            </Name>
            <p>{phoneNumber}</p>
            <p>{email}</p>
          </Personal>
          <Address>
            <p>
              <b>MAILING ADDRESS</b>
            </p>
            <p>{mailingStreetAddress}</p>
            <p>
              {mailingCity} {mailingRegion}
            </p>
            <p>
              {mailingZipCode} {mailingCountry}
            </p>
          </Address>
          <Address>
            <p>
              <b>SHIPPING ADDRESS</b>
            </p>
            <p>{deliveryStreetAddress}</p>
            <p>
              {deliveryCity} {deliveryRegion}
            </p>
            <p>
              {deliveryZipCode} {deliveryCountry}
            </p>
          </Address>
        </Details>
        {showDates && (
          <DatesContainer>
            <MoneyDates>
              {type !== "final invoice" && (
                <>
                  <DateItem>
                    <p>
                      <b>DEPOSIT DUE DATE</b>
                    </p>
                    <DateValue>{depositDue}</DateValue>
                    <DateAmount color={color}>
                      DUE: <span>$6,000</span>
                    </DateAmount>
                  </DateItem>
                  <DateItem>
                    <p>
                      <b>50% DUE DATE</b>
                    </p>
                    <DateValue>{fiftyDue}</DateValue>
                    <DateAmount color={color}>
                      DUE:{" "}
                      <span>
                        {formatter.format(findTotalTax(kits, tax) / 2)}
                      </span>
                    </DateAmount>
                  </DateItem>
                </>
              )}
              <DateItem>
                <p>
                  <b>BALANCE DUE</b>
                </p>
                <DateValue>
                  {fullDue ? (
                    fullDue
                  ) : (
                    <Moment
                      date={new Date(productionDate).getTime() - 14 * 86400000}
                      format="M/D/YYYY"
                    />
                  )}
                </DateValue>

                {/* <p>*or upon receipt of final invoice</p> */}

                {type !== "final invoice" && (
                  <DateAmount color={color}>
                    DUE:{" "}
                    <span>{formatter.format(findTotalTax(kits, tax) / 2)}</span>
                  </DateAmount>
                )}
              </DateItem>
            </MoneyDates>

            <ProductionDates>
              <DateItem>
                <p>
                  <b>PRODUCTION DATE</b>
                </p>
                <DateValue>{productionDate}</DateValue>
              </DateItem>
              <DateItem>
                <p>
                  <b>SHIP DATE</b>
                </p>
                <DateValue>{shipDate}</DateValue>
              </DateItem>
            </ProductionDates>
          </DatesContainer>
        )}

        <TableTop color={color}>
          <div></div>
          <p>ITEM</p>
          <p>AMOUNT</p>
        </TableTop>

        {kits.map((yurt, i) => (
          <PreviewKit
            key={"yurt" + i}
            kit={yurt}
            i={i}
            kitsAmount={kits.length}
            color={color}
          />
        ))}
        <SubTotal color={color}>
          <div>SUB-TOTAL</div>
          <div>
            {formatter.format(findTotalTax(kits, tax) - findTax(kits, tax))}
          </div>
        </SubTotal>
        <Tax>
          <div>Sales Tax</div>

          <div>
            <span>({tax}%)</span> {formatter.format(findTax(kits, tax))}
          </div>
        </Tax>

        <Total color={color}>
          <div>FULL TOTAL</div>
          <div>{formatter.format(findTotalTax(kits, tax))}</div>
        </Total>

        {kits.map((yurt, i) => (
          <div key={i}>
            {yurt.items
              .filter((e) => e.fundsReceived)
              .map((item, k) => (
                <Item>
                  <ItemTitle>{item.title}</ItemTitle>
                  <ItemAmount>{formatter.format(item.amount)}</ItemAmount>
                </Item>
              ))}
          </div>
        ))}

        {kits.filter(({ items }) =>
          items.some(({ fundsReceived }) => fundsReceived)
        ).length ? (
          <BalanceDue color={color}>
            <div>BALANCE DUE</div>
            <div>
              {formatter.format(
                findTotalTax(kits, tax) + findFundsReceived(kits)
              )}
            </div>
          </BalanceDue>
        ) : (
          <></>
        )}

        {document.type === "purchase agreement" && (
          <Important>These prices do not reflect the final invoice*</Important>
        )}

        <Notes style={{ display: notes ? "" : "none" }}>
          <NoteHeader>Notes</NoteHeader>
          <div>{notes}</div>
        </Notes>

        <Terms>
          <PSA>
            {psaDefault ? (
              <div>
                50% of the estimated amount will be due 90 days before your
                production start date. The remaining balance will be due after
                design completion and before the production start date.
              </div>
            ) : (
              <div>{psa}</div>
            )}
          </PSA>
          <Signature>
            <Sign>
              Accepted By: <span></span>
            </Sign>

            <Sign>
              Signed Date: <span></span>
            </Sign>

            <Sign>
              Signature: <span></span>
            </Sign>
          </Signature>
        </Terms>
        <Footer>
          This agreement is subject to the Terms and Conditions as written on
          the subsequent pages.
        </Footer>
      </Container>
    </div>
  );
};

export default PreviewForm;
